import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { MediaCenterCategory, RequestTypesEnum } from '@shared/service-proxies/service-proxies';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService
    ) {}

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem(
                'Dashboard',
                'Pages.Administration.Host.Dashboard',
                'flaticon-line-graph',
                '/app/admin/hostDashboard'
            ),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
            new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),

            //SEEC Management & GOV Team Management
            new AppMenuItem(
                'Administration',
                '',
                'flaticon-interface-8',
                '',
                [],
                [
                    new AppMenuItem(
                        'Sectors',
                        'Pages.Administration.Sectors',
                        'flaticon-more',
                        '/app/admin/sectors/sectors'
                    ),
                    new AppMenuItem(
                        'OrganizationUnits',
                        'Pages.Administration.OrganizationUnits',
                        'flaticon-map',
                        '/app/admin/organization-units'
                    ),
                    new AppMenuItem(
                        'InactiveEntitiesTab',
                        'Pages.StngInactiveEntitieses',
                        'flaticon-map',
                        '/app/admin/organization-units/inActiveEntities'
                    ),
                    new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),

                    // new AppMenuItem(
                    //     'TrainingManagement',
                    //     'Pages.Administration.TrainingMangement',
                    //     'flaticon-interface-8',
                    //     '',
                    //     [],
                    //     [
                    //         new AppMenuItem(
                    //             'TrainingPackages',
                    //             'Pages.Administration.TrainingPackages',
                    //             'flaticon-more',
                    //             '/app/admin/trainingManagement/trainingPackages'
                    //         ),
                    //         new AppMenuItem(
                    //             'Courses',
                    //             'Pages.Administration.Courses',
                    //             'flaticon-more',
                    //             '/app/admin/trainingManagement/courses'
                    //         ),
                    //         new AppMenuItem(
                    //             'Topics',
                    //             'Pages.Administration.Topics',
                    //             'flaticon-more',
                    //             '/app/admin/trainingManagement/topics'
                    //         ),
                    //     ]
                    // ),
                    new AppMenuItem(
                        'PortfolioManagement',
                        'Pages.Administration.OrganizationUnits_View',
                        'flaticon-more',
                        '/app/admin/organization-units/view',
                        [],
                        [],
                        false,
                        { id: this._appSessionService.user.organizationUnitId }
                    ),

                    new AppMenuItem(
                        'AuditLogs',
                        'Pages.Administration.AuditLogs',
                        'flaticon-folder-1',
                        '/app/admin/auditLogs'
                    ),
                    new AppMenuItem(
                        'ManageTeamMembers',
                        'Pages.Administration.GovTeamManagement',
                        'flaticon-users',
                        '/app/admin/gov/members'
                    ),
                    new AppMenuItem(
                        'Languages',
                        'Pages.Administration.Host.Maintenance',
                        'flaticon-tabs',
                        '/app/admin/languages',
                        ['/app/admin/languages/{name}/texts']
                    ),
                    new AppMenuItem(
                        'Roles',
                        'Pages.Administration.Host.Maintenance',
                        'flaticon-suitcase',
                        '/app/admin/roles'
                    ),
                    new AppMenuItem(
                        'Maintenance',
                        'Pages.Administration.Host.Maintenance',
                        'flaticon-lock',
                        '/app/admin/maintenance'
                    ),
                    // new AppMenuItem(
                    //     'Subscription',
                    //     'Pages.Administration.Tenant.SubscriptionManagement',
                    //     'flaticon-refresh',
                    //     '/app/admin/subscription-management'
                    // ),
                    // new AppMenuItem(
                    //     'VisualSettings',
                    //     'Pages.Administration.UiCustomization',
                    //     'flaticon-medical',
                    //     '/app/admin/ui-customization'
                    // ),
                    // new AppMenuItem(
                    //     'WebhookSubscriptions',
                    //     'Pages.Administration.WebhookSubscription',
                    //     'flaticon2-world',
                    //     '/app/admin/webhook-subscriptions'
                    // ),
                    // new AppMenuItem(
                    //     'DynamicProperties',
                    //     'Pages.Administration.DynamicProperties',
                    //     'flaticon-interface-8',
                    //     '/app/admin/dynamic-property'
                    // ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Host.Settings',
                        'flaticon-settings',
                        '/app/admin/hostSettings'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Tenant.Settings',
                        'flaticon-settings',
                        '/app/admin/tenantSettings'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.SeecSettingsAwairness',
                        'flaticon-settings',
                        '/app/admin/seecSettings'
                    ),
                ]
            ),
            new AppMenuItem(
                'TrainingManagement',
                'Pages.Administration.TrainingMangement',
                'flaticon-interface-8',
                '',
                [],
                [
                    new AppMenuItem(
                        'TrainingPackages',
                        'Pages.Administration.TrainingPackages',
                        'flaticon-more',
                        '/app/admin/trainingManagement/trainingPackages'
                    ),
                    new AppMenuItem(
                        'Courses',
                        'Pages.Administration.Courses',
                        'flaticon-more',
                        '/app/admin/trainingManagement/courses'
                    ),
                    new AppMenuItem(
                        'Topics',
                        'Pages.Administration.Topics',
                        'flaticon-more',
                        '/app/admin/trainingManagement/topics'
                    ),
                ]
            ),

            // SEEC Requests
            new AppMenuItem(
                'Requests',
                'Pages.Main.Requests',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'mnuElectricityRequests',
                        'Pages.Main.Requests.TechAdmin',
                        'flaticon-map',
                        '/app/admin/requests/requests'
                    ),
                    
                    new AppMenuItem(
                        'FuelsConsumptionRequests',
                        'Pages.Main.Requests.TechAdmin',
                        'flaticon-map',
                        '/app/admin/requests/requests/fuels-requests'
                    ),
                    
                    new AppMenuItem(
                        'BuildingEnergyEfficiencySubmissionsView',
                        'Pages.Main.Requests.TechAdmin',
                        'flaticon-map',
                        '/app/admin/requests/requests/building-submission-requests'
                    ),
                    new AppMenuItem(
                        'EntitiesManagementRequests',
                        'Pages.Administration.SeecTeamRequestManagement',
                        'flaticon-map',
                        '/app/admin/requests/requests/team-members'
                    ),

                    // new AppMenuItem(
                    //     'BuildingEnergyEfficiencySubmissions',
                    //     'Pages.Administration.BuildingEnergyEfficiencySubmissions.View',
                    //     'flaticon-map',
                    //     '/app/admin/buildingEnergyEfficiencySubmissions/view' //,[],[],false,{requestTypeId : RequestTypesEnum.EnergyEfficiencyPlan}
                    // ),
                    // new AppMenuItem(
                    //     'TrainingAttendanceRequests',
                    //     'SEEC.Administration.TrainingAttendanceRequests',
                    //     'flaticon-map',
                    //     '/app/admin/requests/requests/training-attendance-requests'
                    // ),
                    // new AppMenuItem(
                    //     'TrainingPackagesAdminRequests',
                    //     'Pages.Main.Requests.TrainingPackages',
                    //     'flaticon-map',
                    //     '/app/admin/requests/requests/trainingPackage-requests'
                    // ),
                    // new AppMenuItem(
                    //     'EntitiesManagementRequests',
                    //     'Pages.Administration.SeecTeamRequestManagement',
                    //     'flaticon-map',
                    //     '/app/admin/requests/requests/team-members'
                    // ),
                    // new AppMenuItem(
                    //     'ReopenRequests',
                    //     'Pages.Administration.SeecTeamRequestManagement',
                    //     'flaticon-map',
                    //     '/app/admin/requests/requests/reopen-requests'
                    // )
                  
                ]
            ),

            // SEEC ConsumptionData
            new AppMenuItem(
                'mnuConsumptionData',
                'Pages.Main.Requests.ComparisonData',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'mnuElectricityConsumptionData',
                        'Pages.Main.Requests.TechAdmin.ComparisonData',
                        'flaticon-map',
                        '/app/admin/electricity/comparisonData/view'
                    ),
                    new AppMenuItem(
                        'mnuFeulConsumptionData',
                        'Pages.Main.Requests.TechAdmin.ComparisonData',
                        'flaticon-map',
                        '/app/admin/fuel/comparisonData/view'
                    ),
                    // new AppMenuItem(
                    //       'MonitiringElectricityEEPData',
                    //       ' Pages.Administration.BuildingEnergyEfficiencySubmissions.View',
                    //         'flaticon-map',
                    //         '/app/admin.enerrgyPlan/buildingSubmissions/buildingSubmissions/view'

                    // )
                    new AppMenuItem(
                        'ElectricityHistoricalConsumption',
                        'Pages.Main.Requests.HistoricalConsumption',
                        'flaticon-map',
                        '/app/admin/requests/requests/electricity-historical-consumption'
                    ),
                     new AppMenuItem(
                        'FuelHistoricalConsumption',
                        'Pages.Main.Requests.HistoricalConsumption',
                        'flaticon-map',
                        '/app/admin/requests/requests/fuel-historical-consumption'
                    ),
                ]
            ),

            //GOV Requests
            new AppMenuItem(
                'Requests',
                'Pages.Main.Requests.GovElectricities',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'GovElectricities',
                        'Pages.Main.Requests.GovElectricities',
                        'flaticon-map',
                        '/app/admin/electricity/govElectricities'
                    ),
                 
                    new AppMenuItem('GovFuels', 'Pages.GovFuels', 'flaticon-map', '/app/admin/fuel/govFuels'),
                 
                    new AppMenuItem(
                        'MemberRequests',
                        'Pages.Administration.GovTeamManagement',
                        'flaticon-map',
                        '/app/admin/gov/members/requests'
                    ),
                    new AppMenuItem(
                        'BuildingEnergyEfficiencySubmissions',
                        'Pages.Administration.BuildingEnergyEfficiencySubmissions.View',
                        'flaticon-map',
                        '/app/admin/energyPlan/buildingSubmissions'
                    ),
                    // new AppMenuItem(
                    //     'TrainingAttendanceRequests',
                    //     'Pages.Administration.TrainingRequests',
                    //     'flaticon-more',
                    //     '/app/admin/trainingManagement/attendanceRequests'
                    // ),

                    // new AppMenuItem(
                    //     'ReopenRequests',
                    //     'Pages.Administration.GovTeamManagement',
                    //     'flaticon-map',
                    //     '/app/admin/reopen-requests'
                    // ),
                ]
            ),

            //Elec Provider
            new AppMenuItem(
                'mnuElectricityProviderRequestList',
                'Pages.Administration.ProviderElectricities',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'mnuElectricityProviderRequestList',
                        'Pages.Administration.ProviderElectricities',
                        'flaticon-list',
                        '/app/admin/electricity/providerElectricities'
                    ),
                    new AppMenuItem(
                        'CreateNewProviderElectricity',
                        'Pages.Administration.ProviderElectricities.Create',
                        'flaticon-add',
                        '/app/admin/electricity/providerElectricities/createOrEdit'
                    ),
                ]
            ),

            //Fuel Provider
            new AppMenuItem(
                'mnuFuelProviderRequestList',
                'Pages.Administration.FuelProviderData',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'mnuFuelProviderRequestList',
                        'Pages.Administration.FuelProviderData',
                        'flaticon-list',
                        '/app/admin/fuelProvider/fuelProviderData'
                    ),
                    new AppMenuItem(
                        'CreateNewProviderElectricity',
                        'Pages.Administration.FuelProviderData.Create',
                        'flaticon-add',
                        '/app/admin/fuelProvider/fuelProviderData/addEditRequest'
                    ),
                ]
            ),

            // //EEP menu
            // new AppMenuItem(
            //     'mnuEEP',
            //     'Pages.Administration.OrganizationEEPs',
            //     'flaticon-more',
            //     '',
            //     [],
            //     [

            //         new AppMenuItem('EEPPLansManagementRequests', 'Pages.Administration.EfficiencyPlans', 'flaticon-more', '/app/admin/energyPlan/efficiencyPlans'),
            //         //new AppMenuItem('OrganizationActivityDetails', 'Pages.OrganizationActivityDetails', 'flaticon-more', '/app/admin/energyPlan/organizationActivityDetails'),
            //         //new AppMenuItem('OrganizationActivityDetailsAdmin', 'Pages.OrganizationActivityDetailsAdmin', 'flaticon-more', '/app/admin/energyPlan/organizationActivityDetails/organizationActivityDetailsAdmin'),
            //         //new AppMenuItem('OrganizationElectricityEEPs', 'Pages.Administration.OrganizationEEPs', 'flaticon-more', '/app/admin/energyPlan/organizationEEPs'),
            //         //  new AppMenuItem('OrganizationEEPDetails', 'Pages.Administration.OrganizationEEPs', 'flaticon-more', '/app/admin/energyPlan/organizationEEPDetails'),
            //     ],
            // ),

            // new AppMenuItem(
            //     'DemoUiComponents',
            //     'Pages.DemoUiComponents',
            //     'flaticon-shapes',
            //     '/app/admin/demo-ui-components'
            // ),
            // new AppMenuItem('ProviderElectricities', 'Pages.Administration.ProviderElectricities', 'flaticon-more', '/app/admin/electricity/providerElectricities'),

            new AppMenuItem(
                'AssetsManagement',
                'Pages.Administration.AssetsManagement',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'BuildingAssets',
                        'Pages.Administration.AssetsManagement.BuildingAssetInfos',
                        'flaticon-map',
                        '/app/admin/assetsManagement/buildingAssets',
                        [],
                        [],
                        false,
                        { orgId: undefined }
                    ),
                    new AppMenuItem(
                        'LightingAssets',
                        'Pages.Administration.AssetsManagement.StreetlightAssetInfos',
                        'flaticon-map',
                        '/app/admin/assetsManagement/lightingAssets',
                        [],
                        [],
                        false,
                        { orgId: undefined }
                    ),
                    new AppMenuItem(
                        'FuelAssets',
                        'Pages.Administration.AssetsManagement.FuelAssetInfos',
                        'flaticon-map',
                        '/app/admin/assetsManagement/fuelAssets',
                        [],
                        [],
                        false,
                        { orgId: undefined }
                    ),
                    new AppMenuItem(
                        'CoolingStationAssetInfos',
                        'Pages.Administration.AssetsManagement.CoolingStationAssetInfos',
                        'flaticon-map',
                        '/app/admin/assetsManagement/coolingStationAssets',
                        [],
                        [],
                        false,
                        { orgId: undefined }
                    ),
                    new AppMenuItem(
                        'AssetBulksUpload',
                        'Pages.Administration.AssetsManagement.AssetBulks',
                        'flaticon-map',
                        '/app/admin/assetsManagement/bulkUploadAssets',
                        [],
                        [],
                        false,
                        { orgId: undefined }
                    ),
                ]
            ),

            // Reports
            new AppMenuItem(
                'Reports',
                'Pages.Administration.Reports',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'GovEntitiesElectricityConsumption',
                        'Pages.Administration.Reports.Electricity',
                        'flaticon-list',
                        '/app/admin/reports/gov-entities-electricity-consumption'
                    ),
                    new AppMenuItem(
                        'GovEntitiesFuelConsumption',
                        'Pages.Administration.Reports.Fuel',
                        'flaticon-list',
                        '/app/admin/reports/gov-entities-fuel-consumption'
                    ),
                    new AppMenuItem(
                        'ConsumptionComparisonReport',
                        'Pages.Administration.Reports',
                        'flaticon-list',
                        '/app/admin/reports/consumption-comparison-report'
                    ),
                ]
            ),

            new AppMenuItem(
                'CMS',
                'Pages.Administration.CMSs',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'AboutSeec',
                        'Pages.Administration.AboutSeecs',
                        'flaticon-list',
                        '/app/admin/cms/aboutseec'
                    ),
                    //new AppMenuItem('News', 'Pages.Administration.News', 'flaticon-list', '/app/admin/cms/news'),
                    new AppMenuItem(
                        'Faq',
                        'Pages.Administration.FAQs',
                        'flaticon-list',
                        '',
                        [],
                        [
                            new AppMenuItem(
                                'FaqCategory',
                                'Pages.Administration.FAQCategory',
                                'flaticon-map',
                                '/app/admin/cms/faqCategory'
                            ),
                            new AppMenuItem('Faq', 'Pages.Administration.FAQs', 'flaticon-list', '/app/admin/cms/faq'),
                        ]
                    ),
                    new AppMenuItem(
                        'ContactUsPage',
                        'Pages.Administration.ContactUs',
                        'flaticon-list',
                        '/app/admin/cms/contactus'
                    ),
                    // new AppMenuItem(
                    //     'References',
                    //     'Pages.Administration.References',
                    //     'flaticon-list',
                    //     '/app/admin/cms/reference'
                    // ),
                    new AppMenuItem(
                        'طلبات المستخدمين',
                        'Pages.Administration.CMSs',
                        'flaticon-list',
                        '/app/admin/cms/userRequests'
                    ),
                    new AppMenuItem(
                        'مركز المعرفة',
                        'Pages.Administration.CMSs',
                        'flaticon-list',
                        '/app/admin/cms/knowledge-base'
                    ),
                    new AppMenuItem(
                        'AddAwarnessContent',
                        'Pages.Administration.AwarnessContents',
                        'flaticon-list',
                        '/app/admin/awarnessManagement/awarnessContentAdmin'
                    ),
                ]
            ),
            //Awarness Content Management
            // new AppMenuItem(
            //     'AwarnessManagement',
            //     'Pages.Administration.AwarnessContents',
            //     'flaticon-more',
            //     '',
            //     [],
            //     [
            //         new AppMenuItem(
            //             'AddAwarnessContent',
            //             'Pages.Administration.AwarnessContents',
            //             'flaticon-list',
            //             '/app/admin/awarnessManagement/awarnessContentAdmin'
            //         ),
            //     ]
            // ),
            new AppMenuItem(
                'AwarnessManagement',
                'Pages.Administration.GovAwarnessPublication.List',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'CreateAwarnessPublicationTitle',
                        'Pages.Administration.GovAwarnessPublication.List',
                        'flaticon-list',
                        '/app/admin/awarnessManagement/gov'
                    ),
                ]
            ),

            new AppMenuItem(
                'المركز الإعلامي',
                '',
                'flaticon-more',
                '',
                [],
                [
                    new AppMenuItem(
                        'الأخبار',
                        'Pages.Administration.MediaCenter',
                        'flaticon-list',
                        '/app/admin/media-center',
                        [],
                        [],
                        false,
                        { category: MediaCenterCategory.News }
                    ),
                    new AppMenuItem(
                        'الفعاليات',
                        'Pages.Administration.MediaCenter',
                        'flaticon-list',
                        '/app/admin/media-center',
                        [],
                        [],
                        false,
                        { category: MediaCenterCategory.Events }
                    ),
                    new AppMenuItem(
                        'مركز الوسائط',
                        'Pages.Administration.MediaCenter',
                        'flaticon-list',
                        '/app/admin/media-center',
                        [],
                        [],
                        false,
                        { category: MediaCenterCategory.MediaLibrary }
                    ),
                    // new AppMenuItem(
                    //     'References',
                    //     'Pages.Administration.References',
                    //     'flaticon-list',
                    //     '/app/admin/cms/reference/references-list'
                    // ),
                ]
            ),
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }
        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
